module.exports = __webpack_public_path__ + "img/f2.0cac39e1.jpg";